import React, { useEffect } from "react";
import DocumentTitle from "react-document-title";
import { setHtmlClass } from "@/utils/utils";
import styles from "@/css/agreement.module.less";

const UserAgreement = () => {
  useEffect(() => {
    setHtmlClass(styles["init-css"]);
  }, []);
  return (
    <DocumentTitle title="用户协议">
      <div className={styles["main"]}>
        {/* <h2>用户协议</h2> */}
        <p>
          <strong>重要须知</strong>：
        </p>
        <p>
          《用户协议》（下称“本协议”）是用户与深圳市网心科技有限公司（以下简称“网
          心公司”）之间就用户使用星域测速软件（以下简称“本软件”）所订立的协议。
        </p>
        <p>
          <strong className={styles["underline-text"]}>
            我们在此特别提醒用户认真阅读本协议中各条款，尤其是免除或者限制我们责任的免责条款及对用户的权利限制条款。除非您接受本协议条款，否则您无权使用本协议项下的服务。您的
            使用 行为将视为对本协议的接受，并同意接受本协议各项条款的约束。
          </strong>
        </p>
        <h3>一、协议的确认和接纳</h3>
        <p>
          1.请您审阅并接受或不接受本协议（未成年人应在法定监护人陪同下审阅，未成年人行使和履行本协议项下的权利和义务视为其已获得了法定监护人的认可）。除非您接受本协议条款，否则您无权使用本软件。
        </p>
        <p>
          2.用户一经点击同意本协议并使用本软件
          ，则本协议立即成立且生效，即表示用户自愿接受本协议的所有内容。
        </p>
        <p>3.本软件的著作权和运营权均归网心公司所有。</p>
        <h3>二 、本软件功能说明</h3>
        <p>
          1.本软件为用户提供设备网络测速服务，即测试本软件安装设备在测速时的网络运营商、网络速度等参数。
        </p>
        <p>
          2.网络测速结果
          会受用户计算机性能、资源使用情况、网络高峰期、网站服务能力、线路等因素影响，因此本软件提供的
          网络测速结果
          会与实际接入的网络速度存在偏差，结果只供参考，本软件不承诺绝对正确性。
        </p>
        <h3>三、用户行为规范</h3>
        <p>
          1.
          本软件暂时无需注册账户；如本软件需要注册账户时会另行通知用户，用户届时
          应提供真实、有效的信息，并妥善保管账号；用户因信息提交不真实、不完整、效力存在瑕疵等原因而遭受损失的，应自行承担相应损失。
        </p>
        <p>
          <strong className={styles["underline-text"]}>
            2. 用户的账号（如有
            ）仅限注册人自身使用，禁止用户赠与、借用、租用、转让或售卖。如网心公司发现使用者并非账户初始注册人，网心公司有权在未经通知的情况下封停该账号且无需承担任何法律责任，由此可能带来的损失由用户自行承担。
          </strong>
        </p>
        <p>3.用户不得在本软件内有如下行为：</p>
        <ul>
          <li>
            <p>（1）制作、发表、复制、传送、传播、储存以下信息：</p>
            <ul>
              <li>①违反宪法确定的基本原则的；</li>
              <li>
                ②危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；
              </li>
              <li>③损害国家荣誉和利益的；</li>
              <li>
                ④煽动民族仇恨、民族歧视，破坏民族团结的；破坏国家宗教政策，宣扬邪教和封建迷信的；
              </li>
              <li>
                ⑤散布谣言，扰乱社会秩序，破坏社会稳定的；煽动非法集会、结社、游行、示威、聚众扰乱社会秩序的；以非法民间组织名义活动的；
              </li>
              <li>⑥散布淫秽、色情、赌博、暴力、恐怖或者教唆犯罪的；</li>
              <li>⑦侮辱或者诽谤他人，侵害他人合法权益的；</li>
              <li>⑧侵犯他人知识产权、商业秘密或其他合法权利的；</li>
              <li>⑨含有法律、行政法规禁止的其他内容的。</li>
            </ul>
          </li>
          <li>
            <p>（2）实施包括但不限于下列行为：</p>
            <ul>
              <li>①删除本软件及其他副本上所有关于版权的信息、内容；</li>
              <li>②对本软件进行反向工程、反向汇编、反向编译等；</li>
              <li>
                ③未经网心公司书面同意，擅自使用、复制、修改、链接、转载、汇编、发表、出版，建立镜像站点、擅自借助本软件发展与之有关的衍生产品、作品、服务等；
              </li>
              <li>
                ④未经允许，对本软件中可能存储、处理或者传输的数据进行删除、修改或者增加的；
              </li>
              <li>
                ⑤未经许可，探查、扫描、测试本软件弱点或干扰本软件正常运行或其它实施破坏本软件安全的；
              </li>
              <li>⑥故意制作、传播计算机病毒等破坏性程序的；</li>
              <li>⑦其他危害计算机信息网络安全的行为。</li>
            </ul>
          </li>
        </ul>
        <p>
          如用户有以上行为的，网心公司有权对用户进行暂停或永久封号、暂停或无效交易（如有）等处理。
        </p>
        <h3>四、账号体系及隐私保护</h3>
        <p>
          1.用户使用本软件暂时无需注册；如本软件需要您注册时，会另行通知用户并获取用户同意。
        </p>
        <p>
          2.尊重用户个人隐私是网心公司的一项基本政策。网心公司会采取必要措施保护用户的个人信息资料的安全。网心公司在未经用户授权时不得公开、编辑或透露其用户资料及保存在本平台中的非公开内容，但“许可的披露或者授权”除外。
        </p>
        <p>“许可的披露或授权”是指：</p>
        <ul>
          <li>（1）用户或用户监护人授权网心公司披露的；</li>
          <li>（2）司法机关或行政机关基于法定程序要求网心提供的；</li>
          <li>（3）网心为了维护自己合法权益而向用户提起诉讼或者仲裁时；</li>
          <li>（4）应用户监护人的合法要求而提供用户个人身份信息时；</li>
          <li>（5）在紧急情况下竭力维护用户个人和社会大众的隐私安全时；</li>
          <li>
            （6）因用户侵犯其他用户或者其他第三方权益导致网心被起诉的情形下，网心可基于独立判断向法院提供该用户信息；
          </li>
          <li>（7）用户违反本协议和/或相应活动运营规则时；</li>
          <li>（8）根据本协议相关规定或者网心认为必要的其他情况下。</li>
        </ul>
        <p>
          3.用户理解并知晓个人隐私信息是指那些能够对用户进行个人辨识或涉及个人通信的信息，包括下列信息：用户的姓名，身份证号，手机号码，IP地址，电子邮件、联系方式、家庭地址等信息。而非个人隐私信息是指用户对本平台的操作状态以及使用习惯等一些明确且客观反映在网心服务器端的基本记录信息和其他一切个人隐私信息范围外的普通信息。
        </p>
        <p>4.一般而言，网心公司基于下列原因需要使用到用户的信息：</p>
        <ul>
          <li>（1）执行升级服务、检测软件和设备状态；</li>
          <li>（2）进行网络同步服务时；</li>
          <li>（3）提高用户的使用安全性并提供客户支持时；</li>
          <li>
            （4）因用户使用特定功能或因用户要求网心或合作单位提供特定服务时，网心公司需要使用该用户的信息或将该用户信息提供给与此相关联的第三方；
          </li>
          <li>（5）其他有同时利于用户和网心利益的。</li>
        </ul>
        <p>
          用户理解并同意，网心基于上述原因使用信息不会构成网心对本协议项下隐私保护义务的违反。
        </p>
        <p>
          5.在不透露单个用户隐私资料的前提下，网心有权对整个用户数据库进行分析并对用户数据库进行商业上的利用。
        </p>
        <p>6.未成年人隐私权的保护</p>
        <ul>
          <li>
            （1）网心公司郑重声明：任何18岁以下的未成年人参加网上活动应事先得到家长或其法定监护人（以下统称为“监护人”）的可经查证的同意；监护人应承担保护未成年人在网络环境下的隐私权的首要责任。
          </li>
          <li>
            （2）未经监护人之同意，网心公司不会使用未成年人之个人资料，亦不会向任何第三方披露或传送可识别该未成人的个人资料，但根据相关法律法规、应有关国家机关要求及许可的披露或授权的除外。
          </li>
        </ul>
        <h3>五、其他</h3>
        <p>1.本协议的生效、履行、解释及争议解决均适用中华人民共和国法律。</p>
        <p>
          2.本协议所定的任何条款、承诺、条件或约定，由于无论何种原因成为不合法的、无效的或不可执行的，该不合法、无效或不可申请执行，并不影响其它条款的效力。
        </p>
        <p>
          <strong className={styles["underline-text"]}>
            3.如就本协议内容或其执行发生任何争议，应尽量友好协商解决；协商不成时，则争议各方均应提请深圳仲裁委员会按照该会届时有效的仲裁规则进行仲裁。
          </strong>
        </p>
      </div>
    </DocumentTitle>
  );
};
export default UserAgreement;
